import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { CustomEvalService } from "../../../../../app/modules/CustomEval/custom-eval.service";
import { AppService } from "../../../../../app/app.service";
import {
  ComponentImageListVm,
  ComponentModel,
  SystemModel,
  UpdateComponentMeasurementModel,
  UpdateTrackFrameConfigurationRequest,
} from "../../../../../app/modules/interpretation/models/interpretation.model";
import { LoadingService } from "../../../../shared/services/loading.service";
import { AddCrackRecordsDialogComponent } from "../../components/add-crack-records-dialog/add-crack-records-dialog.component";
import { FramecomponentPhotoPopupComponent } from "../../components/framecomponent-photo-popup/framecomponent-photo-popup.component";
import { PhotoPopupComponent } from "../../components/photo-popup/photo-popup.component";
import { WsreSendReportComponent } from "../../components/wsre-send-report/wsre-send-report.component";
import {
  ArrivalPhotoOverview,
  ComponentCrackImagesFrame,
  ComponentFrameComment,
  ComponentSummary,
  componentTabFrames,
  ComponentTabRecord,
  CrackTestSummary,
  CrackTestTab,
  DipTest,
  DipTestConditionType,
  DipTestSummary,
  InitialImageType,
  WSREActionHistoryVM,
  WsreCompartMeasurementPoints,
  WSREFrameComponentsRecordsVM,
  WSREFrameCrackRecordsVM,
} from "../../models/wsre.model";
import { WsreService } from "../../wsre.service";
import { UserService } from "../../../../../app/shared/services/user.service";
import {
  CustomeEvaluationRangeVM,
  WSreStatusModel,
  UpdateJobDetailsRequest,
} from "../../../../../app/modules/CustomEval/custom-eval.model";
import { InterpretationService } from "../../../../../app/modules/interpretation/interpretation.service";
import { HttpParams } from "@angular/common/http";
import { AddThermographyInspectionDetailsCommentComponent } from "../../../../../app/modules/Thermography/create-new-thermography-inspection/add-temp-inspection-details-comment/add-thermography-inspection-details-comment";
import { AttachFileDialogComponent } from "../../../../../app/modules/document-in-library/attach-file-dialog/attach-file-dialog.component";
import {
  AttachmentsVM,
  WSREFrameComponentDocumnetVM,
} from "../../../../../app/modules/GET_NEW_UI/setup-implement/setup-implement.model";
import { MultiplePhotoUploadComponent } from "../../../../../app/modules/interpretation/components/multiple-photo-upload/multiple-photo-upload.component";
import {
  ComponentOnSystemViewModel,
  GeneralActionViewModel,
  ReplacementCompartmentViewModel,
} from "../../../../../app/modules/action/action-models";
//import { SystemComponentViewModel } from 'src/app/modules/inventory/inventory-models';
//import { InventoryService } from 'src/app/modules/inventory/inventory-service.service';
import {
  AvailableActionsForComponentInInventoryWSRE,
  AvailableActionViewModelNew,
} from "../../wrse.model";
import { ActionService } from "../../../../../app/modules/action/action.service.service";
import { SystemComponentViewModel } from "../../../../../app/modules/inventory/inventory-models";
import { Tuple } from "../../../../../app/entities";
import { InventoryService } from "../../../../../app/modules/inventory/inventory-service.service";
import { RecordActionHistoryPopup } from "../record-action-history-popup/record-action-history-popup.component";
import { TranslateService } from "../../../../../app/translate";
import {
  ScreenCode,
  toolType,
  toolTypePassFail,
  toolTypeYesNo,
} from "../../../../shared/enums/allEnums";
import {
  trigger,
  transition,
  style,
  animate,
  keyframes,
} from "@angular/animations";
import { ManageEquipmentService } from "../../../../modules/manage-equipment/manage-equipment.service";
import { PageEvent } from "@angular/material/paginator";
import { CommonFiltersService } from "../../../../shared/services/common-search-filters.service";
import { ChangeComponentComponent } from "../../../../modules/manage-equipment/components/change-component/change-component.component";
import { CustomerServiceIdentity } from "../../../../modules/IDENTITY_WEB/services/customer.service";

@Component({
  selector: "app-repair-estimate-frame",
  templateUrl: "./repair-estimate-frame.component.html",
  styleUrls: ["./repair-estimate-frame.component.scss"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 0 }),
        animate("0ms", style({ opacity: 0 })),
      ]),
    ]),
    trigger("slideOut", [
      transition(":enter", [
        style({ "max-height": "0" }),
        animate(
          "5s",
          keyframes([
            style({ "max-height": "200px", offset: 0 }),
            style({ "max-height": "400px", offset: 0.3 }),
            style({ "max-height": "600px", offset: 0.6 }),
            style({ "max-height": "1400px", offset: 0.9 }),
          ]),
        ),
      ]),
    ]),
  ],
})
export class RepairEstimateFrameComponent implements OnInit {
  SystemTypeId: number;
  wsreId;
  compartID;
  measurement;
  userCanEdit: boolean = false;
  side: number;
  // Overview at top of page
  customerName: string;
  customerReference: string;
  inspectionDate: Date;
  jobNumber: string;
  isJobNumberEditable: boolean = false;
  originalJobNumber: string = "";

  jobsiteName: string;
  lifeLived: number;
  make: string;
  model: string;
  oldJobNumber: string;
  reportPrepared: boolean = false;
  serialNumber: string;
  serialNumberRight?: string;
  frameRHSide: number;
  frameLHSide: number;
  frameRHSideName: string;
  frameLHSideName: string;
  CustomerframeLHSide: string;
  CustomerframeRHSide: string;

  // Summary tab
  loadingSummary: boolean = true;
  overallEval: string;
  OverallEvalR: string;
  overallSummaryComment: string;
  overallSummaryCommentRightSide: string;
  overallSummaryRecommendation: string;
  overallSummaryRecommendationRightSide: string;
  overallComponentLeft: string;
  overallComponentRight: string;

  componentSummaries: ComponentSummary[];
  crackTestSummary: CrackTestSummary;
  dipTestSummaries: DipTestSummary[];
  savingOverallEval: boolean = false;
  savingOverallEval_R: boolean = false;
  // Arrival Photos Tab
  arrivalPhotosLoaded: boolean = false;
  arrivalPhotos: ArrivalPhotoOverview[] = [];
  arrivalPhotos_L: ArrivalPhotoOverview[] = [];
  arrivalPhotos_R: ArrivalPhotoOverview[] = [];

  finalPhotosLoaded: boolean = false;
  finalPhotos: ArrivalPhotoOverview[] = [];
  finalPhotos_R: ArrivalPhotoOverview[] = [];
  finalPhotos_L: ArrivalPhotoOverview[] = [];

  customerReferencePhotos: ArrivalPhotoOverview[] = [];
  customerReferencePhotos_L: ArrivalPhotoOverview[] = [];
  customerReferencePhotos_R: ArrivalPhotoOverview[] = [];
  oldTagPhotos: ArrivalPhotoOverview[] = [];
  oldTagPhotos_L: ArrivalPhotoOverview[] = [];
  oldTagPhotos_R: ArrivalPhotoOverview[] = [];

  failedIronPhotos: ArrivalPhotoOverview[] = [];
  failedIronPhotos_L: ArrivalPhotoOverview[] = [];
  failedIronPhotos_R: ArrivalPhotoOverview[] = [];

  // Components Tab
  componentsLoaded: boolean = false;
  components: componentTabFrames[] = [];
  components_: componentTabFrames[] = [];
  ComponentCrackImages: ComponentCrackImagesFrame[] = [];
  isshowDiv: boolean = true;
  ishowMeasurementpointtables: boolean = false;
  crackComment: ComponentFrameComment[] = [];
  crackComment_: string = "";
  isIncludeReport: boolean = false;

  FrameInspectedSide: number;
  // Crack Test Tab
  // crackTestLoaded: boolean = false;
  // crackTest: CrackTestTab = new CrackTestTab;
  // savingCrackTestEval: boolean = false;

  // Dip Tests Tab
  //dipTestsLoaded: boolean = false;
  // dipTests: DipTest[] = [];
  // possibleDipTestConditions: DipTestConditionType[] = [];

  viewPhotos: boolean = false;
  viewComponents: boolean = false;
  viewCrackTests: boolean = false;
  viewDipTests: boolean = false;

  Comment: string;

  LeftSideSystem: SystemModel;
  RightSideSystem: SystemModel;

  isEnableMaxRange: boolean;
  isEnableFinalMeasurement: boolean;
  isEnableSpecs: boolean;
  userLanguage = "english";

  FrameConfigurationId: number;
  toolType = toolType;
  toolTypeYesNo = toolTypeYesNo;
  toolTypePassFail = toolTypePassFail;
  isSerialNumberEditable: boolean = false;
  castFrameLeft: number = 0;
  castFrameRight: number = 0;
  toeOutFrameLeft: number = 0;
  toeOutFrameRight: number = 0;
  screenId = ScreenCode;
  systemIdRight: string;
  systemIdLeft: string;
  auditTrailHistory: WSREActionHistoryVM[] = [];
  loadSize: number = 25;
  loadingPage: number = 1;
  auditTrailTotalRecords: number = 0;
  isFrameRHSideEditable: boolean = false;
  auditRefreshCounter = 0;
  isJobSiteEditable: boolean = false;
  selectedJobSiteId: number = 0;
  jobSiteList: any[] = [];
  customerId: number;
  isBasicUser: number = 1;
  isAdministrator: boolean = false;
  allowFieldEditing: boolean = false;
  allowJobsiteEditing: boolean = false;
  viewTab(event) {
    console.log(event.index, event);
    this.viewPhotos = false;
    this.viewComponents = false;
    this.viewCrackTests = false;
    this.viewDipTests = false;
    this.loadingSummary = true;

    switch (event.tab.textLabel) {
      case "Summary":
        this.loadingSummary = false;
        break;
      case "Arrival Photos":
        this.viewPhotos = true;
        break;
      case "Components":
        this.viewComponents = true;
        break;
      case "Crack Tests":
        this.viewCrackTests = true;
        break;
      case "Dip Tests":
        this.viewDipTests = true;
        break;
      case "Audit Trail":
        this.auditRefreshCounter++;
        break;
    }
  }
  actionHelper: AvailableActionsForComponentInInventoryWSRE =
    new AvailableActionsForComponentInInventoryWSRE();
  @ViewChild("popup") popup: ElementRef;
  constructor(
    private _dialog: MatDialog,
    private _titleService: Title,
    private _wsreService: WsreService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _service: NotificationsService,
    private _app: AppService,
    private _evalService: CustomEvalService,
    private _interp: InterpretationService,
    private _sanitizer: DomSanitizer,
    private _loading: LoadingService,
    public dialog: MatDialog,
    private eRef: ElementRef,
    private loadingService: LoadingService,
    private inventoryService: InventoryService,
    private _actionService: ActionService,
    private notification: NotificationsService,
    private _userService: UserService,
    private _translate: TranslateService,
    private _equipment: ManageEquipmentService,
    private _commonService: CommonFiltersService,
    private _customerService: CustomerServiceIdentity
  ) {}

  ngOnInit() {
    this._titleService.setTitle("Undercarriage Rebuild Centre");
    this.wsreId = this._route.snapshot.params.id;
    this.SystemTypeId = this._route.snapshot.params.id2;
    this.GetWRSEFinalDisplayStatus();
    this._app
      .getApplicationConfigValue("EnableMaxRangeForEvaluation")
      .subscribe((result) => {
        if (result == "1") {
          this.isEnableMaxRange = true;
        } else {
          this.isEnableMaxRange = false;
        }
      });
    this._customerService.CheckUCUserType().subscribe(result => {
      this.isBasicUser = result;
    });
    // this._app.getApplicationConfigValue("ShowHideFinalReadingWSRE").subscribe(result => {

    //   if (result == "1") {
    //     this.isEnableFinalMeasurement = true;
    //   } else {
    //     this.isEnableFinalMeasurement = false;
    //   }
    // });
    this._app
      .getApplicationConfigValue("ShowHideSpecsWSRE")
      .subscribe((result) => {
        if (result == "1") {
          this.isEnableSpecs = true;
        } else {
          this.isEnableSpecs = false;
        }
      });
    this.LoadEvalautionForEquipment();
    this.checkUserCanEdit();
    this.checkUserRoleForEditPermissions();
    this.loadOverview();
    this.loadSummary();
    this.loadArrivalPhotos();
    this.GetWSRECurrentStatus();
    this.loadComponentCrackphotos();
    this.LoadFrameComponentsLeftAndRight();
    this.LoadWsreStatus();
    //this.GetComponentFrameComment()
  }

  availableActions: AvailableActionViewModelNew[] = [];

  activeAction: boolean;

  public editableBudgetLife: boolean = true;
  public currentClickedId: number = 0;

  togglePencilClick() {
    this.TogglePencil = !this.TogglePencil;
  }
  selectedOption: string | null = null;

  isLoadEdit = false;
  public TogglePencil: boolean = false;
  systemId: number = 0;
  allComponents: ComponentOnSystemViewModel[];
  ReplaceComponentCompartId: number;

  loadActions(componenttypeID: number, componentid: number, c: any) {
    this.isLoadEdit = false;
    this.isPopupVisible = false;
    this.currentClickedId = componentid;
    this.isPopupVisible = !this.isPopupVisible;
    this.availableActions = this.actionHelper.GetActions(componenttypeID);
    if (c == "Left") {
      this.systemId = this.LeftSideSystem.Id;
    } else {
      this.systemId = this.RightSideSystem.Id;
    }
    this._actionService
      .getComponentsOnThisSystem(this.systemId)
      .subscribe((r) => {
        console.log(r);
        this.allComponents = r;
      });
    console.log(this.availableActions);
  }
  isPopupVisible: boolean = false;

  loadOverview() {
    this._wsreService
      .GetRepairEstimateOverviewFrame(this.wsreId)
      .subscribe((wsre) => {
        if (wsre == null) {
          this._service.error(
            "Error",
            "Cannot find an estimate with this ID. ",
          );
          return;
        }
        this.customerName = wsre.CustomerName;
        this.customerReference = wsre.CustomerReference;
        this.inspectionDate = wsre.InspectionDate;
        this.jobNumber = wsre.JobNumber;
        this.jobsiteName = wsre.JobsiteName;
        this.lifeLived = wsre.LifeLived;
        this.make = wsre.Make;
        this.model = wsre.Model;
        this.oldJobNumber = wsre.OldJobNumber;
        this.reportPrepared = wsre.ReportPrepared;
        this.serialNumber = wsre.SerialNumber;
        this.frameRHSide = wsre.TrackFrame_Right_SystemId;
        this.frameLHSide = wsre.TrackFrame_Left_SystemId;
        this.CustomerframeLHSide = wsre.TrackFrame_Customer_L_Serial;
        this.CustomerframeRHSide = wsre.TrackFrame_Customer_R_Serial;
        this.frameLHSideName = wsre.TrackFrame_Left_SystemName;
        this.frameRHSideName = wsre.TrackFrame_Right_SystemName;
        this.FrameInspectedSide = wsre.FrameInspectedSide;
        this.castFrameLeft = wsre.CastFrameLeft;
        this.castFrameRight = wsre.CastFrameRight;
        this.toeOutFrameLeft = wsre.ToeOutFrameLeft;
        this.toeOutFrameRight = wsre.ToeOutFrameRight;
        this.systemIdLeft = wsre.TrackFrame_Left_SystemId?.toString() ?? "";
        this.systemIdRight = wsre.TrackFrame_Right_SystemId?.toString() ?? "";
        this.customerId = wsre.CustomerId;
        this.loadComponentTab();
      });
  }

  loadSummary() {
    this._loading.startLoading();
    this._wsreService
      .GetRepairEstimateSummaryFrameRightSide(this.wsreId)
      .subscribe((wsre) => {
        if (wsre == null) {
          this._loading.finishedLoading();
          return;
        }
        this.overallEval = wsre.OverallEval;
        this.OverallEvalR = wsre.OverallEval_R;
        this.overallSummaryComment = wsre.OverallComment;
        this.overallSummaryCommentRightSide = wsre.TrackFrameOverallComment_R;
        this.overallSummaryRecommendation = wsre.OverallRecommendation;
        this.overallSummaryRecommendationRightSide =
          wsre.TrackFramOverallRecommendation_R;
        this.componentSummaries = wsre.Components;
        this.crackTestSummary = wsre.CrackTest;
        this.dipTestSummaries = wsre.DipTests;
        this.loadingSummary = false;
        this.FrameConfigurationId = wsre.FrameConfigurationId;
        this.overallComponentLeft = wsre.overallComponentLeft;
        this.overallComponentRight = wsre.overallComponentRight;

        this._loading.finishedLoading();
      });
  }

  saveOverallSummaryComment(comment: string, screenId: number) {
    this._loading.startLoading();
    this._wsreService
      .updateOverallSummaryComment(this.wsreId, comment, screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success(
            "Left Overall Summary Comment Saved",
            result.m_Item2,
          );
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallSummaryCommentRightSide(comment: string, screenId: number) {
    this._loading.startLoading();
    this._wsreService
      .updateOverallSummaryCommentRightSide(this.wsreId, comment, screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success(
            "Right Overall Summary Comment Saved",
            result.m_Item2,
          );
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallSummaryRecommendation(recommendation: string, screenId: number) {
    this._loading.startLoading();
    this._wsreService
      .updateOverallSummaryRecommendation(this.wsreId, recommendation, screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Left Failed Iron Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallSummaryRecommendationRightSide(
    recommendation: string,
    screenId: number,
  ) {
    this._loading.startLoading();
    this._wsreService
      .updateOverallSummaryRecommendationRightSide(
        this.wsreId,
        recommendation,
        screenId,
      )
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Right Failed Iron Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallFrameCompComment(comment: string, side: number, screenId: number) {
    this._loading.startLoading();
    this._wsreService
      .updateOverallFrameComponentComment(this.wsreId, comment, side, screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success(result.m_Item2);
          //this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallEval(overallEval: string, screenId: number) {
    this.savingOverallEval = true;
    this._loading.startLoading();
    this._wsreService
      .updateOverallEval(this.wsreId, overallEval, screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Left Overall Eval Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
        this.savingOverallEval = false;
      });
  }

  saveOverallEval_R(overallEval: string, screenId: number) {
    this.savingOverallEval_R = true;
    this._loading.startLoading();
    this._wsreService
      .UpdateOverallEvalFrame_R(this.wsreId, overallEval, screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Right Overall Eval Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
        this.savingOverallEval_R = false;
      });
  }

  FrameConfigurationChange(event: any) {
    this._loading.startLoading();
    this._wsreService
      .updateWSREFrameConfiguration(this.wsreId, event.value)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveFrameConfiguration(
    type: number,
    selectedValue: number,
    side: number,
  ): void {
    const request: UpdateTrackFrameConfigurationRequest = {
      WsreId: this.wsreId,
      SelectedValue: selectedValue == 1 ? true : false,
      Type: type,
      SystemInspectedSide: side,
    };
    this._wsreService.updateWSREFrameConfigurationNEW(request).subscribe({
      next: (res) => {
        if (res?.Status) {
          this._service.success("Saved", res.Message);
        } else {
          this._service.error("Error", res?.Message || "Update failed");
        }
      },
      error: (err) => {
        console.error(err);
        this._service.error("Error", "Something went wrong");
      },
    });
  }

  checkUserCanEdit() {
    this._wsreService.checkUserCanEdit(this.wsreId).subscribe((canEdit) => {
      this.userCanEdit = canEdit;
    });
  }

  loadArrivalPhotos() {
    this._loading.startLoading();
    this._wsreService
      .getArrivalPhotosOverviewFrame(this.wsreId)
      .subscribe((photos) => {
        if (photos == null) {
          this._loading.finishedLoading();
          return;
        }

        console.log("getArrivalPhotosOverview", photos);
        this.arrivalPhotos = photos.filter((p) =>
          p.Type == InitialImageType.Arrival ? true : false,
        );
        this.oldTagPhotos = photos.filter((p) =>
          p.Type == InitialImageType.OldTag ? true : false && p.side == 1,
        );
        this.finalPhotos = photos.filter((p) =>
          p.Type == InitialImageType.Final ? true : false && p.side == 1,
        );
        this.customerReferencePhotos = photos.filter((p) =>
          p.Type == InitialImageType.CustomerReference
            ? true
            : false && p.side == 1,
        );
        this.failedIronPhotos = photos.filter((p) =>
          p.Type == InitialImageType.FailedIron ? true : false && p.side == 1,
        );

        this.arrivalPhotos_L = this.arrivalPhotos.filter((f) => f.side == 1);
        this.arrivalPhotos_R = this.arrivalPhotos.filter((f) => f.side == 2);

        this.finalPhotos_L = this.finalPhotos.filter((f) => f.side == 1);
        this.finalPhotos_R = this.finalPhotos.filter((f) => f.side == 2);

        this.customerReferencePhotos_L = this.customerReferencePhotos.filter(
          (f) => f.side == 1,
        );
        this.customerReferencePhotos_R = this.customerReferencePhotos.filter(
          (f) => f.side == 2,
        );

        this.oldTagPhotos_L = this.oldTagPhotos.filter((f) => f.side == 1);
        this.oldTagPhotos_R = this.oldTagPhotos.filter((f) => f.side == 2);

        this.failedIronPhotos_L = this.failedIronPhotos.filter(
          (f) => f.side == 1,
        );
        this.failedIronPhotos_R = this.failedIronPhotos.filter(
          (f) => f.side == 2,
        );

        this._loading.finishedLoading();
      });
  }

  uploadArrivalPhotos(result) {
    if (result) this.loadArrivalPhotos();
  }

  uploadFinalPhotos(result) {
    if (result) this.loadArrivalPhotos();
  }

  customerReferencePhotoUploaded(result) {
    if (result) this.loadArrivalPhotos();
  }

  oldTagPhotoUploaded(result) {
    if (result) this.loadArrivalPhotos();
  }

  failedIronPhotoUploaded(result) {
    if (result) this.loadArrivalPhotos();
  }

  openImage(photoId: number, photoType: string, childId: number | null) {
    let dialogRef = this.dialog.open(PhotoPopupComponent, {
      panelClass: "removeModalOverflow",
      data: {
        photoId: photoId,
        photoType: photoType,
        userCanDeletePhoto: this.userCanEdit,
        childId: childId,
        ScreenId: 2,
      },
    });
    dialogRef.afterClosed().subscribe((wasDeleted) => {
      if (wasDeleted) {
        switch (photoType) {
          case "initial":
            this.loadArrivalPhotos();
            break;
          case "component":
            // this.loadComponentTab();
            break;
          case "cracktest":
            //  this.loadCrackTestTab();
            break;
          case "diptest":
            // this.loadDipTestTab();
            break;
          default:
          // this.loadComponentTab();
        }
      }
    });
  }
  checkboxChanged(event) {
    this.isshowDiv = event.checked;
    // this.isCanonHousingshow=event.checked
    console.log(this.isshowDiv);
  }
  checkboxChangedMeasuremwntPoints(event, component: componentTabFrames) {
    this.ishowMeasurementpointtables = event.checked;
    component.isShowMeasurementPoints = event.checked;
    console.log("measuremetn point checkboc=z", event.checked);
    console.log(
      "component.isShowMeasurementPoints",
      component.isShowMeasurementPoints,
    );
    console.log(
      "component.measurementPointName",
      component.measurementPointName,
    );
  }
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(
      "data:image/png;base64," + image,
    );
  }
  includeReportCheckboxchange(event: any, photo: ArrivalPhotoOverview) {
    console.log(photo);
    console.log(event.checked);
    this._wsreService
      .UpdateIncludeReortPhotoFrame(
        photo.Id,
        this.wsreId,
        photo.Type,
        photo.side,
        event.checked,
        2,
      )
      .subscribe((res) => {
        if (res == true) {
          this._service.success("Saved");
        } else this._service.error("Error");
      });
  }
  changeisMainPhoto(event: any) {
    console.log(
      event.value.Id,
      this.wsreId,
      event.value.Type,
      event.value.side,
    );
    this._wsreService
      .UpdateIsMainPhotoFrame(
        event.value.Id,
        this.wsreId,
        event.value.Type,
        event.value.side,
        2,
      )
      .subscribe((res) => {
        if (res == true) {
          this._service.success("Saved");
        } else this._service.error("Error");
      });
  }
  //component tab data

  //New TT-6612
  EvalautionRange: CustomeEvaluationRangeVM;
  WSREStatusLeftSide: WSreStatusModel[];
  WSREStatusRightSide: WSreStatusModel[];

  AddComment(
    InspectionDetailId: number,
    comment: string,
    isedit: boolean,
    side: number,
    system: number,
    screenId: number,
  ) {
    const newInspectionDetailCommentDialog = this._dialog.open(
      AddThermographyInspectionDetailsCommentComponent,
      {
        panelClass: "removeModalOverflow",
        data: {
          equipmentId: 0,
          inspectionDetailID: InspectionDetailId,
          Inspcomment: comment,
          isedit: isedit,
          isWsre: true,
          screenId: screenId,
        },
        minWidth: 500,
      },
    );

    newInspectionDetailCommentDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.LoadFrameComponentsLeftAndRight();
        //this.loadTemperatureInspection();
        //this.LoadMoreInspections();
      }
    });
  }
  loadPhoto(component: ComponentModel) {
    this._wsreService
      .getComponentPhotoListWSREFrame(component.InspectionDetailId, this.wsreId)
      .subscribe((res) => {
        if (res) {
          component.ComponentImages = res;
        }
      });
  }

  LoadObsPointFrameImage(
    CompartMeasurementPointId: number,
    obsPoint: WsreCompartMeasurementPoints,
    side: number,
    measurementPointId: number,
    IsFinalMeasurementImg: boolean,
  ) {
    this._wsreService
      .getObspointPhotoListWSREFrame(
        CompartMeasurementPointId,
        this.wsreId,
        side,
        measurementPointId,
        IsFinalMeasurementImg,
      )
      .subscribe((res) => {
        if (res.photo1 != null) {
          if (side == 1 && res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_L_Final = res.photo1;
          else if (side == 1 && !res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_L = res.photo1;
          else if (side == 2 && res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_R_Final = res.photo1;
          else if (side == 2 && !res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_R = res.photo1;

          //this.updateComment = res.m_Item2;
        } else {
          if (side == 1 && res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_L_Final = "";
          else if (side == 1 && !res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_L = "";
          else if (side == 2 && res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_R_Final = "";
          else if (side == 2 && !res.IsFinalMeasurmentImage)
            obsPoint.PhotoThumbnail_R = "";
        }
      });
    //component.Comment = this.updateComment;
  }

  viewComponentPhoto(
    photoId: number,
    inspectionDetailId: number,
    side: number,
    obsPoint: WsreCompartMeasurementPoints,
    measurementPointId: number,
    IsFinalMeasurementImg: boolean,
  ) {
    //console.log("id__1",photoId)
    //const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    const viewPhotoModalRef = this._dialog.open(MultiplePhotoUploadComponent, {
      width: "800px",

      data: {
        inspectionId: this.wsreId,
        photoId: photoId,
        inspectionDetailId: inspectionDetailId,
        isWsreFrameObsImage: true,
        measurementPointId: measurementPointId,
        side: side,
        IsFinalMeasurementImg: IsFinalMeasurementImg,
        ScreenId: 2,
      },
    });
    viewPhotoModalRef.afterClosed().subscribe((reloadPhoto) => {
      if (reloadPhoto)
        this.LoadObsPointFrameImage(
          inspectionDetailId,
          obsPoint,
          side,
          measurementPointId,
          IsFinalMeasurementImg,
        ); //this.loadSystem();
    });
  }
  GetEvalColour(comp: ComponentModel, worn: number) {
    var compType = comp.ComponentTypeId;

    if (
      comp.Measurement === -1 ||
      comp.ToolId === toolType.YESorNO ||
      comp.ToolId === toolType.PassorFail
    ) {
      return "Eval-U";
    }
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA) return "Eval-A";
          else if (worn <= this.EvalautionRange.LinkB) return "Eval-B";
          else if (worn <= this.EvalautionRange.LinkC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.LinkA) return "Eval-A";
          else if (worn <= this.EvalautionRange.LinkB) return "Eval-B";
          else return "Eval-X";
        }

      case 231: //Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA) return "Eval-A";
          else if (worn <= this.EvalautionRange.BushB) return "Eval-B";
          else if (worn <= this.EvalautionRange.BushC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.BushA) return "Eval-A";
          else if (worn <= this.EvalautionRange.BushB) return "Eval-B";
          else return "Eval-X";
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA) return "Eval-A";
          else if (worn <= this.EvalautionRange.ShoeB) return "Eval-B";
          else if (worn <= this.EvalautionRange.ShoeC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.ShoeA) return "Eval-A";
          else if (worn <= this.EvalautionRange.ShoeB) return "Eval-B";
          else return "Eval-X";
        }

      case 233: //Idler
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA) return "Eval-A";
          else if (worn <= this.EvalautionRange.LinkB) return "Eval-B";
          else if (worn <= this.EvalautionRange.LinkC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.LinkA) return "Eval-A";
          else if (worn <= this.EvalautionRange.LinkB) return "Eval-B";
          else return "Eval-X";
        }

      case 234: //carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA) return "Eval-A";
          else if (worn <= this.EvalautionRange.CarrierRollerB) return "Eval-B";
          else if (worn <= this.EvalautionRange.CarrierRollerC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA) return "Eval-A";
          else if (worn <= this.EvalautionRange.CarrierRollerB) return "Eval-B";
          else return "Eval-X";
        }

      case 235: //track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA) return "Eval-A";
          else if (worn <= this.EvalautionRange.TrackRollerB) return "Eval-B";
          else if (worn <= this.EvalautionRange.TrackRollerC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA) return "Eval-A";
          else if (worn <= this.EvalautionRange.TrackRollerB) return "Eval-B";
          else return "Eval-X";
        }
      case 236: //Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA) return "Eval-A";
          else if (worn <= this.EvalautionRange.SprocketB) return "Eval-B";
          else if (worn <= this.EvalautionRange.SprocketC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.SprocketA) return "Eval-A";
          else if (worn <= this.EvalautionRange.SprocketB) return "Eval-B";
          else return "Eval-X";
        }

      case 240: //Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA) return "Eval-A";
          else if (worn <= this.EvalautionRange.ElongationB) return "Eval-B";
          else if (worn <= this.EvalautionRange.ElongationC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.ElongationA) return "Eval-A";
          else if (worn <= this.EvalautionRange.ElongationB) return "Eval-B";
          else return "Eval-X";
        }

      case 417: //Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA) return "Eval-A";
          else if (worn <= this.EvalautionRange.CrawlerGuideB) return "Eval-B";
          else if (worn <= this.EvalautionRange.CrawlerGuideC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA) return "Eval-A";
          else if (worn <= this.EvalautionRange.CrawlerGuideB) return "Eval-B";
          else return "Eval-X";
        }

      case 446: //RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA) return "Eval-A";
          else if (worn <= this.EvalautionRange.RSRearIdlerB) return "Eval-B";
          else if (worn <= this.EvalautionRange.RSRearIdlerC) return "Eval-C";
          else return "Eval-X";
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA) return "Eval-A";
          else if (worn <= this.EvalautionRange.RSRearIdlerB) return "Eval-B";
          else return "Eval-X";
        }
      case 237: //Idler
        if (worn <= 30) return "Eval-A";
        else if (worn <= 50) return "Eval-B";
        else if (worn <= 70) return "Eval-C";
        else return "Eval-X";

      default:
        break;
    }
  }
  changeEval(
    selectedEval: string,
    inspectionDetailId: number,
    compType: number,
    screenId: number,
  ) {
    const measurement = this._app.getEvalToolMeasurementPoint_Worn(
      selectedEval,
      compType,
      this.EvalautionRange,
      this.isEnableMaxRange,
    );

    const m = new UpdateComponentMeasurementModel(
      this.wsreId,
      inspectionDetailId,
      measurement,
      1,
      9,
      this.EvalautionRange,
      screenId,
    );
    this._wsreService.UpdateWSREFrameComponentMeasurement(m).subscribe(
      (r) => {
        if (r.m_Item1) {
          this.LoadFrameComponentsLeftAndRight();
        } else {
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }
  public updateComponentMeasurement(
    measurement: number,
    inspectionDetailId: number,
    event: any,
    component: ComponentModel,
    screenId: number,
  ) {
    if (event != null) {
      measurement = event.target.value;
    } else {
      measurement = measurement;
    }
    //console.log("event____11111", event.target.value)
    const m = new UpdateComponentMeasurementModel(
      this.wsreId,
      inspectionDetailId,
      measurement,
      1,
      -1,
      this.EvalautionRange,
      screenId,
    );

    this._wsreService.UpdateWSREFrameComponentMeasurement(m).subscribe(
      (r) => {
        if (r.m_Item1) {
          //this.loadSystem();
          //this.measurementPointUpdated.emit();
          let comp = new SystemComponentViewModel();
          comp.ComponentId = component.ComponentId;
          comp.Brand = component.Brand;
          comp.CompartId = component.CompartId_Auto;
          comp.Budget = 0;
          comp.CMU = component.Cmu;
          comp.CompartType = component.ComponentTypeId;
          comp.ComponentId = component.ComponentId;
          comp.EqunitId = component.ComponentId;
          comp.MakeId = component.MakeId;
          comp.MeasurementPoints = measurement;
          comp.ToolId = component.ToolId;
          comp.Name = component.Name;
          //TT-9974
          comp.DOC = component.DOC;
          this.measurementChanged(measurement, comp);

          this.LoadFrameComponentsLeftAndRight();
          // this._notify.success('Updated', r.m_Item2);
        } else {
          //this._notify.error('Failed', 'Unable to update component measurement. ');
          console.error(r.m_Item2);
        }
      },
      (err) => {
        //this._notify.error('Failed', 'Unable to update component measurement. ');
        console.error(err);
      },
    );
  }
  LoadEvalautionForEquipment() {
    this._evalService
      .GetSelectedLevelRangesForSelectedEquipment(0)
      .subscribe((res) => {
        this.EvalautionRange = res;
      });
  }
  WSREStatusIDRightSide: number;
  WSREStatusIDLeftSide: number;

  LoadWsreStatus() {
    this._evalService.LoadWsreStatus().subscribe((res) => {
      this.WSREStatusLeftSide = res;
      this.WSREStatusRightSide = res;
    });
  }

  public updateComponentTool(
    measurement: number,
    inspectionDetailId: number,
    toolId: number,
    screenId: number,
  ) {
    const m = new UpdateComponentMeasurementModel(
      this.wsreId,
      inspectionDetailId,
      measurement,
      1,
      toolId,
      this.EvalautionRange,
      screenId,
    );
    if (toolId === 9) m.Measurement = 30;
    this._wsreService.UpdateWSREFrameComponentMeasurement(m).subscribe(
      (r) => {
        if (r.m_Item1) {
          this.LoadFrameComponentsLeftAndRight();
        } else {
          console.error(r.m_Item2);
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }
  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }
  showPosition(
    position: number,
    compartTypeId: number,
    system: SystemModel,
  ): string {
    let hasSameComponent = system.Components.filter(
      (x) => x.ComponentTypeId == compartTypeId && x.IsChild == false,
    );
    if (hasSameComponent.length > 1) {
      return this.getPositionStringDoubleComponents(position, compartTypeId);
    } else {
      return this._app.getPositionString(position, compartTypeId);
    }
    // if(this.system.Components.length >4){
    //         return this.getPositionStringDoubleComponents(position,compartTypeId);
    // }else{
    //     return this._app.getPositionString(position, compartTypeId);
    // }
  }

  getPositionStringDoubleComponents(
    Pos: number,
    CompartTypeId: number,
  ): string {
    if (CompartTypeId === 233)
      if (Pos === 1)
        // Idler
        return "Front";
      else if (Pos === 2) return "Rear";
    if (CompartTypeId === 234 && Pos === 1)
      // Carrier roller
      return "Front";
    if (
      (CompartTypeId >= 230 && CompartTypeId <= 232) ||
      CompartTypeId === 236 ||
      CompartTypeId === 237 ||
      CompartTypeId === 240
    ) {
      // Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return "Front";
      else if (Pos === 2) return "Rear";
    }
    if (CompartTypeId == 446) return "Rear";
    return Pos.toString();
  }
  getComponent(componentId: number, system: SystemModel): ComponentModel {
    return system.Components.find((c) => c.ComponentId === componentId);
  }

  getChildRowPosition(componentId: number, system: SystemModel): string {
    const component = this.getComponent(componentId, system);
    const children = system.Components.filter(
      (c) => c.ComponentTypeId === component.ComponentTypeId && c.IsChild,
    );
    if (children[0].ComponentId === componentId) return "--extended";
    if (children[children.length - 1].ComponentId === componentId)
      return "--half";
    return "";
  }

  UpdateVisibilityForComponent(inspectionDetailId: number, IsVisisble: number) {
    this._wsreService
      .WSREUpdateVisibityOfFrameComponents(inspectionDetailId)
      .subscribe((res) => {
        if (res.m_Item1) {
          this._service.success(res.m_Item2);
          this.LoadFrameComponentsLeftAndRight();
        } else {
          this._service.error("Error", "Please try again.");
        }
      });
  }
  LoadFrameComponentsLeftAndRight() {
    // this._loading.startLoading();
    this._wsreService
      .GetComponentTabDataFramesLeftAndRight(this.wsreId)
      .subscribe((res) => {
        console.log("res", res);

        this.LeftSideSystem = res[0];
        this.RightSideSystem = res[1];
      });
  }
  isMeasurementWithintheRange: boolean;
  loadComponentTab() {
    this._loading.startLoading();
    this._wsreService
      .GetComponentTabDataFrames(this.wsreId, this.customerName)
      .subscribe((components) => {
        console.log("components", components);
        this.components_ = components;
        this.components = this.components_.filter(
          (f) => f.CompartMeasurementPoints.length > 0,
        );

        if (this.components != null) this.componentsLoaded = true;
        this._loading.finishedLoading();
      });
  }

  saveComponentMeasurementLeft(
    newMeasurement,
    compartId: number,
    side: number,
    name: string,
    Id: number,
    IsOkMeasurmemnt: boolean,
  ) {
    console.log("newMeasurement", newMeasurement);
    if (isNaN(newMeasurement)) {
      this._service.error(
        "Error",
        "Please enter a valid measurement. Eg: 10.004",
      );
      return;
    }

    this._loading.startLoading();
    var model = new WSREFrameComponentsRecordsVM();
    model.WSREInspectionID = this.wsreId;
    model.ComponentId = compartId;
    //model.measurement = newMeasurement == "" ? -987654 : newMeasurement;
    model.measurement = newMeasurement;

    model.side = side;
    model.measurementPointName = name;
    model.MeasurementPointId = Id;
    model.MeasurementIsOk = IsOkMeasurmemnt;
    model.ScreenId = 2;
    console.log("model__", model);

    this._wsreService
      .UpdateComponentRecordMeasurementFrameLeft(model)
      .subscribe((result) => {
        console.log(result);
        if (result) {
          this._service.success("Left Measurement Saved");
          this.loadComponentTab();
          this.loadSummary();
        } else {
          this._service.error("Error", result);
        }
        this._loading.finishedLoading();
      });
  }
  saveComponentFinalMeasurementLeft(
    newMeasurement,
    compartId: number,
    side: number,
    name: string,
    Id: number,
    IsOkMeasurmemnt: boolean,
  ) {
    console.log("newMeasurement", newMeasurement);
    if (isNaN(newMeasurement)) {
      this._service.error(
        "Error",
        "Please enter a valid measurement. Eg: 10.004",
      );
      return;
    }

    this._loading.startLoading();
    var model = new WSREFrameComponentsRecordsVM();
    model.WSREInspectionID = this.wsreId;
    model.ComponentId = compartId;
    //model.measurement = newMeasurement == "" ? -987654 : newMeasurement;
    model.measurement = newMeasurement;

    model.side = side;
    model.measurementPointName = name;
    model.MeasurementPointId = Id;
    model.ScreenId = 2;
    console.log("model__", model);

    this._wsreService
      .UpdateComponentFinalRecordMeasurementFrameLeft(model)
      .subscribe((result) => {
        console.log(result);
        if (result) {
          this._service.success("Left Final Measurement Saved");
          this.loadComponentTab();
          this.loadSummary();
        } else {
          this._service.error("Error", result);
        }
        this._loading.finishedLoading();
      });
  }

  ChangeIsOkCheckbox(
    value: number,
    side: number,
    compart: WsreCompartMeasurementPoints,
  ) {
    if (side == 1) //left
    {
      if (value == 1) {
        this.saveComponentMeasurementLeft(
          compart.Measurement,
          compart.compartId,
          1,
          compart.compartName,
          compart.Id,
          true,
        );
      } else if (value == 2) {
        this.saveComponentMeasurementLeft(
          compart.Measurement,
          compart.compartId,
          1,
          compart.compartName,
          compart.Id,
          false,
        );
      } else {
        this.saveComponentMeasurementLeft(
          compart.Measurement,
          compart.compartId,
          1,
          compart.compartName,
          compart.Id,
          null,
        );
      }
    } else {
      if (value == 1) {
        this.saveComponentMeasurementRight(
          compart.Measurement_RIGHT,
          compart.compartId,
          2,
          compart.compartName,
          compart.Id,
          true,
        );
      } else if (value == 2) {
        this.saveComponentMeasurementRight(
          compart.Measurement_RIGHT,
          compart.compartId,
          2,
          compart.compartName,
          compart.Id,
          false,
        );
      } else {
        this.saveComponentMeasurementRight(
          compart.Measurement_RIGHT,
          compart.compartId,
          2,
          compart.compartName,
          compart.Id,
          null,
        );
      }
    }
  }

  saveComponentMeasurementRight(
    newMeasurement,
    compartId: number,
    side: number,
    name: string,
    Id: number,
    isMeasurementIsOK: boolean,
  ) {
    if (isNaN(newMeasurement)) {
      this._service.error(
        "Error",
        "Please enter a valid measurement. Eg: 10.004",
      );
      return;
    }
    // if (newMeasurement != null) {
    this._loading.startLoading();
    var model = new WSREFrameComponentsRecordsVM();
    model.WSREInspectionID = this.wsreId;
    model.ComponentId = compartId;
    // model.measurement = newMeasurement == "" ? -123456 : newMeasurement;
    model.measurement = newMeasurement;
    model.side = side;
    model.measurementPointName = name;
    model.MeasurementPointId = Id;
    model.MeasurementIsOk = isMeasurementIsOK;
    model.ScreenId = 2;
    this._wsreService
      .UpdateComponentRecordMeasurementFrameRight(model)
      .subscribe((result) => {
        console.log("result", result);
        if (result) {
          this._service.success("Right Measurement Saved");
          this.loadComponentTab();
          this.loadSummary();
        } else {
          this._service.error("Error");
        }
        this._loading.finishedLoading();
      });
    //}
  }

  saveComponentFinalMeasurementRight(
    newMeasurement,
    compartId: number,
    side: number,
    name: string,
    Id: number,
    isMeasurementIsOK: boolean,
  ) {
    if (isNaN(newMeasurement)) {
      this._service.error(
        "Error",
        "Please enter a valid measurement. Eg: 10.004",
      );
      return;
    }
    // if (newMeasurement != null) {
    this._loading.startLoading();
    var model = new WSREFrameComponentsRecordsVM();
    model.WSREInspectionID = this.wsreId;
    model.ComponentId = compartId;
    // model.measurement = newMeasurement == "" ? -123456 : newMeasurement;
    model.measurement = newMeasurement;
    model.side = side;
    model.measurementPointName = name;
    model.MeasurementPointId = Id;
    model.ScreenId = 2;
    this._wsreService
      .UpdateComponentFinalRecordMeasurementFrameRight(model)
      .subscribe((result) => {
        console.log("result", result);
        if (result) {
          this._service.success("Right Final Measurement Saved");
          this.loadComponentTab();
          this.loadSummary();
        } else {
          this._service.error("Error");
        }
        this._loading.finishedLoading();
      });
    //}
  }

  loadComponentCrackphotos() {
    this._wsreService
      .GetComponentCrackPhotoFrame(this.wsreId)
      .subscribe((result) => {
        this.ComponentCrackImages = result;
        console.log("ComponentCrackImages", this.ComponentCrackImages);
      });
  }
  uploadComponentCrackPhotos(result) {
    if (result) this.loadComponentCrackphotos();
    this.loadComponentTab();
    this.loadComponentTab();
    console.log(result);
  }

  saveComponentCommentFrame(event: any, WSREMeasurementPointId, side) {
    let model = new ComponentFrameComment();
    model.WSREInspectionID = this.wsreId;
    model.WSREMeasurementPointId = WSREMeasurementPointId;
    model.comment = event.target.value;
    model.side = side;
    model.ScreenId = 2;
    this._wsreService.saveComponentCommentFrame(model).subscribe((result) => {
      this.loadComponentTab();
    });
  }

  GetComponentFrameComment() {
    this._wsreService
      .GetComponentFrameComment(this.wsreId)
      .subscribe((result) => {
        console.log(result);
        this.crackComment = result;
      });
  }

  openComponentImage(
    photoId: number,
    photoType: string,
    childId: number | null,
  ) {
    let dialogRef = this.dialog.open(FramecomponentPhotoPopupComponent, {
      panelClass: "removeModalOverflow",
      data: {
        photoId: photoId,
        photoType: photoType,
        userCanDeletePhoto: this.userCanEdit,
        childId: childId,
      },
    });

    dialogRef.afterClosed().subscribe((wasDeleted) => {
      if (wasDeleted && photoType != "framecomp") {
        this.loadComponentCrackphotos();
        this.loadComponentTab();
      } else {
        this.LoadFrameComponentsLeftAndRight();
      }
    });
  }
  containers: WSREFrameCrackRecordsVM;
  containers_: WSREFrameCrackRecordsVM[];

  addContainers(component: WSREFrameCrackRecordsVM) {
    //   var x = {
    //     foo: function() { return 1; },
    //     bar: function() { return  2;}
    // };
    // console.log(x.foo());
  }

  UpdateCrackNameFrame(
    event: any,
    frameCrackRecordID,
    WSREMeasurementPointId,
    side,
  ) {
    this._wsreService
      .UpdateCrackNameFrame(
        this.wsreId,
        frameCrackRecordID,
        WSREMeasurementPointId,
        event.target.value,
        side,
        2,
      )
      .subscribe((result) => {
        console.log(result);
        this.loadComponentTab();
      });
  }

  UpdateCrackCommentFrame(
    event: any,
    frameCrackRecordID,
    WSREMeasurementPointId,
    side,
  ) {
    this._wsreService
      .UpdateCrackCommentFrame(
        this.wsreId,
        frameCrackRecordID,
        WSREMeasurementPointId,
        event.target.value,
        side,
        2,
      )
      .subscribe((result) => {
        console.log(result);
        this.loadComponentTab();
      });
  }

  UpdateCrackLength(
    event: any,
    frameCrackRecordID,
    WSREMeasurementPointId,
    side,
  ) {
    this._wsreService
      .UpdateCrackLength(
        this.wsreId,
        frameCrackRecordID,
        WSREMeasurementPointId,
        event.target.value,
        side,
        2,
      )
      .subscribe((result) => {
        console.log(result);
        this.loadComponentTab();
      });
  }

  uploadCrackPhotos(result, Id: componentTabFrames) {
    if (result) this.loadComponentCrackphotos();
    console.log(result);
    this.loadComponentTab();
  }

  openCrackrecordDialog(componentID, side) {
    let dialogRef = this.dialog.open(AddCrackRecordsDialogComponent, {
      panelClass: "removeModalOverflow",
      data: {
        MeasurementPointID: componentID,
        wsreId: this.wsreId,
        side: side,
      },
    });

    dialogRef.afterClosed().subscribe((wasDeleted) => {
      this.loadComponentCrackphotos();
      this.loadComponentTab();
    });
  }
  // GetComponentImageFrame()
  // {
  //   this._wsreService.GetComponentImageFrame(this.Id).subscribe(result => {
  //     console.log(result)
  //    // this.crackComment=result
  //       })

  // }

  sendReport() {
    let sendReportModalRef = this.dialog.open(WsreSendReportComponent, {
      width: "640px",
      height: "500px",
      data: {
        WSREInspectionID: this.wsreId,
        type: 3,
      },
    });
    sendReportModalRef.afterClosed().subscribe((res) => {
      if (res != null) {
        // var sendToAddress: string = res.data;
        // this._rbService.SendReport(this.MSInspectionID, sendToAddress).subscribe(r2 => {
        //     if (r2 != null && r2 == true) {
        //         alert("Successfully sent report.");
        //     } else {
        //         alert("Failed to send report!");
        //     }
        // });
      }
    });
  }

  GetPdfIdler(wsreId: number) {
    //     console.log("report works")
    //   window.open(this.appUris.UCUri + 'api/WSRE/GetPdfIdler?wsreId=' + wsreId, '_blank');
    // }
  }
  FilePreview: string = "";
  FileName: string = "";
  NewFileName: string = "";

  openAttachDoc(component: componentTabFrames) {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      data: {
        acceptedTypes: ".pdf",
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      console.log("res", res);
      if (res != false) {
        var images_ = res.FilePreview.split(",");
        this.FilePreview = images_[1];
        this.FileName = res.NewFileName;
        // this.NewFileName =component.measurementPointName+" Document";

        this.NewFileName = component.measurementPointName + " Document";
        let params = new WSREFrameComponentDocumnetVM();
        params.WSREId = this.wsreId;
        params.ComponentId = component.Id;
        params.FileData = this.FilePreview;

        console.log("params", params);
        this._wsreService
          .saveFrameComponentDocument(params)
          .subscribe((res) => {
            if (res > 0) {
              component.DocumnetData = this.FilePreview;
              component.FileName = component.measurementPointName + " Document";

              this._service.success("Document Added successfully");
            } else {
              this._service.error(
                "Error",
                "Please check the attached document",
              );
            }
          });
      }
    });
  }

  onClickDownloadForm(comp: componentTabFrames) {
    this.FilePreview = comp.DocumnetData;
    var arrBuffer = this.base64ToArrayBuffer(this.FilePreview);
    var blob = new Blob([arrBuffer], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = comp.measurementPointName + " Document";
    link.click();
  }

  base64ToArrayBuffer(base64) {
    console.log("base64", base64);
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  displayFinalMeasurementChanged(event) {
    //this.isEnableSpecs = event.checked;
    this._evalService
      .ToggleWRSEFinalDisplay(this.wsreId, event.checked)
      .subscribe((res: any) => {
        this.isEnableFinalMeasurement = res;
      });
  }

  // displayFinalMeasurementChanged(event) {
  //   this._app.setApplicationConfigValue(event.checked ? "1" : "0", "ShowHideFinalReadingWSRE").subscribe(res => {
  //     if (res) {
  //       this.isEnableFinalMeasurement = event.checked;
  //     }
  //   })
  // }

  GetWRSEFinalDisplayStatus() {
    this._evalService
      .GetWRSEFinalDisplayStatus(this.wsreId)
      .subscribe((res: any) => {
        this.isEnableFinalMeasurement = res;
      });
  }
  displaySpecs(event) {
    this._app
      .setApplicationConfigValue(event.checked ? "1" : "0", "ShowHideSpecsWSRE")
      .subscribe((res) => {
        if (res) {
          this.isEnableSpecs = event.checked;
        }
      });
  }

  GetWSRECurrentStatus() {
    this._evalService
      .GetWSRECurrentStatus(this.wsreId)
      .subscribe((res: any) => {
        if (res != null) {
          this.WSREStatusIDLeftSide = res.LeftSideStatus;
          this.WSREStatusIDRightSide = res.RightSideStatus;
        }
      });
  }

  popupClose() {
    if (this.isPopupVisible) this.isPopupVisible = false;
  }
  action = new GeneralActionViewModel();

  replacementCompartChanged(event, EqunitId: number) {
    // get budget life
    console.log(event);
    this.loadingService.startLoading();
    // this.action.ReplaceComponentCompartId = this.component.
    this._actionService.getComponentBudgetLife(EqunitId).subscribe((l: any) => {
      this.loadingService.finishedLoading();
      this.action.BudgetLife = l;
    });
  }
  swapRollerEvent(selectedRoller: ComponentOnSystemViewModel) {
    this.action.NewEqUnitId = selectedRoller.GeneralEqunitId;
  }
  RecordAction() {
    this.action.WsreId = this.wsreId;
    this.action.SystemType = 3;
    this.action.ActionEqUnitId = this.currentClickedId;
    this.action.ActionTypeId = this.selectedActionTypeID;
    // this.action.ReplaceComponentCompartId=
    this._actionService.recordNewInventoryAction(this.action).subscribe((a) => {
      console.log(a);
      if (a.m_Item1) {
        this.notification.success("Successfully Recorded WSRE Action");
        this.LoadFrameComponentsLeftAndRight();
      } else {
        this.notification.error(
          "Failed to Recorded Inventory Action  " + a.m_Item2,
        );
        console.log(a.m_Item2);
      }
      this.selectedActionTypeID = 0;
      this.selectedOption = "";
      this.isPopupVisible = false;
    });
  }
  selectedActionTypeID: number;
  allRollers: ComponentOnSystemViewModel[];
  isloadingReplacementCompart: boolean;
  isReplaceWithNewAction;
  availableCompartments: ReplacementCompartmentViewModel[] = [];
  onCheckboxChange(option: any, CompartTypeID: number, componentID: number) {
    // Toggle logic: if the clicked checkbox is already selected, deselect it.
    this.selectedOption = this.selectedOption === option ? null : option;
    this.selectedActionTypeID = this.availableActions.find(
      (x) => x.ActionTypeName == option.ActionTypeName,
    ).ActionTypeId;
    this.action.ActionTypeName = option.ActionTypeName;
    const checkString = option.ActionTypeName.split(" ");
    if (checkString[0] === "Replace") {
      //this.loadingService.startLoading();
      //this.isloadingReplacementCompart = true;
      this.isReplaceWithNewAction = true;
      this._actionService
        .getReplacementComponentOptions(componentID)
        .subscribe((r) => {
          //this.loadingService.finishedLoading();
          this.isloadingReplacementCompart = false;
          console.log(r);
          this.availableCompartments = r;
          console.log(this.availableCompartments);
        });
    } else {
      this.isReplaceWithNewAction = false;
    }

    if (
      +this.selectedActionTypeID === 10602 ||
      +this.selectedActionTypeID === 17 ||
      +this.selectedActionTypeID === 10702
    ) {
      this.allRollers = this.allComponents.filter(
        (c) => c.CompartTypeId === CompartTypeID,
      );
    }
  }

  measurementChanged(event, component: SystemComponentViewModel) {
    component.LastestInpsectionId = 0;
    // this.loadingService.startLoading();
    this.inventoryService
      .getWornPercentageCalculationMethod(
        component.CompartId,
        component.ToolId,
        event,
        component.LastestInpsectionId,
        component.ComponentId,
      )
      .subscribe((r) => {
        component.WornPercentage = r.m_Item1;
        component.Condition = r.m_Item2;
        this.inventoryService
          .updateSystemInInventoryInfo(component)
          .subscribe((res) => {
            this.popupNotification(res);
          });
        this.loadingService.finishedLoading();
      });
  }
  private popupNotification(result: Tuple) {
    this.loadingService.finishedLoading();
    if (result.m_Item1) {
      this.notification.success(result.m_Item2);
    } else {
      this.notification.error(result.m_Item2);
    }
  }

  OnStatusChange(value: number, screenId: number) {
    let side: string;
    let statusId: number = 0;
    if (value == 1) {
      side = "Left";
      statusId = this.WSREStatusIDLeftSide;
    } else {
      side = "Right";
      statusId = this.WSREStatusIDRightSide;
    }
    this.inventoryService
      .UpdateWsreStatus(this.wsreId, statusId, side, screenId)
      .subscribe((a) => {
        if (a == true) {
          this.notification.success("Updated Successfully");
        } else {
          this.notification.error("Something went wrong");
        }
      });
  }
  toggleJobNumberEdit(editable: boolean): void {
    if (this.allowFieldEditing) {
      this.isJobNumberEditable = editable;
    }
  }

  toggleSerialNumberEdit(editable: boolean): void {
    if (this.allowFieldEditing) {
      this.isSerialNumberEditable = editable;
    }
  }

  toggleJobSiteEdit(value: boolean) {
    if (this.allowJobsiteEditing) {
      this.allowJobsiteEditing = value;
      this.getJobsite();
    }
  }

  saveSerialNumber() {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: 2
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.toggleSerialNumberEdit(false);
      },
      error: (err) => {
        console.error("Error saving Job Number:", err);
      },
    });
  }

  saveJobNumber() {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: 2
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.isSerialNumberEditable = false;
      },
      error: (err) => {
        console.error("Error saving Serial Number:", err);
      },
    });
  }
  // Example value
  isCustomerReferenceEditable: boolean = false;

  toggleCustomerReferenceEdit(isEditable: boolean): void {
    this.isCustomerReferenceEditable = isEditable;
  }

  // saveCustomerReference(): void {
  //   // Add your save logic here
  //   console.log('Customer Reference Saved:', this.customerReference);
  //   this.toggleCustomerReferenceEdit(false);
  // }
  saveCustomerReference(): void {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: 2
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.toggleCustomerReferenceEdit(false);
      },
      error: (err) => {
        console.error("Error saving Customer Reference:", err);
      },
    });
  }

  // Example value
  isOldJobNumberEditable: boolean = false;

  toggleOldJobNumberEdit(isEditable: boolean): void {
    this.isOldJobNumberEditable = isEditable;
  }

  toggleFrameRHSideEdit(isEditable: boolean): void {
    this.isFrameRHSideEditable = isEditable;
  }

  saveFrameRHSide() {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      serialNumberRight: this.frameRHSideName,
      ScreenId: 2
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        this.notification.success("Record saved successfully", response);
        this.toggleFrameRHSideEdit(false);
      },
      error: (err) => {
        console.error("Error saving Frame RHS Side:", err);
      },
    });
  }

  saveOldJobNumber(): void {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: 2
    };
    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.toggleOldJobNumberEdit(false);
      },
      error: (err) => {
        console.error("Error saving Old Job Number:", err);
      },
    });
  }

  checkUserRoleForEditPermissions(): void {
    this.allowFieldEditing = false;
    this._userService.getUserJobRoles().subscribe((roles) => {
      roles.forEach((role) => {
        if (role.Name === "Administrator" || role.Name === "Customer Admin") {
          this.allowFieldEditing = true;
          this.isAdministrator = true;
        }
        if (role.AllowEdit) this.allowJobsiteEditing = true;
      });
    });
  }

  openHistory(component: any) {
    const viewCommentModalRef = this._dialog.open(RecordActionHistoryPopup, {
      data: {
        component: component.ComponentId,
      },
    });
    viewCommentModalRef.afterClosed().subscribe((reloadComment) => {});
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  getPhotoThumbnail(image: string) {
    //console.log(" image.", image.replace(".", "Thumbnail_S."));
    return image.replace(
      "." + this.getPhotoExtension(image),
      "Thumbnail_S." + this.getPhotoExtension(image),
    );
  }

  getPhotoExtension(image: string): string {
    const parts = image.split(".");
    if (parts.length > 1) {
      return parts.pop() || ""; // Get last part after the last dot
    }
    return ""; // No extension found
  }

  onFrameConfigChange(type: number, sValue: number, systemId: number): void {
    console.log("type", type);
    console.log("value", sValue);
    let value = sValue == 1 ? true : false;

    this._equipment
      .updateTrackFrameConfiguration(systemId, value, type, 0, 0, ScreenCode.WF)
      .subscribe({
        next: () => {
          this.notification.success(
            "Saved",
            "Update Track Frame Configuration.",
          );
        },
        error: () => {
          this.notification.error(
            "Error",
            "Failed to update Track Frame Configuration.",
          );
        },
      });
  }

  loadActionHistory(loadingPage: number, pageSize: number) {
    const ids = [this.systemIdLeft, this.systemIdRight].filter(
      (id) => id != null,
    );
    const systemIds: string = ids.length ? ids.join(",") : "";
    this._loading.startLoading();
    this._wsreService
      .getActionHistory(systemIds, 2, 4, loadingPage, pageSize)
      .subscribe({
        next: (res) => {
          this.auditTrailHistory = res.Data;
          this.auditTrailTotalRecords = res.TotalRecords;
        },
        error: (err) => {
          console.error("Failed to load history", err);
        },
        complete: () => {
          this._loading.finishedLoading();
        },
      });
  }
  pageChanged(event: PageEvent) {
    console.log(event);
    this.loadActionHistory(event.pageIndex + 1, event.pageSize);
  }

  isImage(value: string | null | undefined): boolean {
    if (!value) return false;
    const lower = value.toLowerCase();
    return (
      lower.endsWith(".png") ||
      lower.endsWith(".jpg") ||
      lower.endsWith(".jpeg") ||
      lower.endsWith(".ico")
    );
  }

  getJobsite() {
    this._commonService.getJobsiteList(this.customerId).subscribe((res) => {
      this.jobSiteList = res;
    });
  }

  saveJobSite(site: any) {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      JobsiteId: site.Id,
      ScreenId: 2
    };
    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Jobsite saved successfully"), response);
        this.jobsiteName = site.Name;
      },
      error: (err) => {
        console.error("Error saving Jobsite:", err);
      },
    });
  }
  openEditComponentPopup(component: ComponentModel) {
        //console.log("comparttype_auto: number, compartid_auto: number", CompartId, CompartTypeId);
        const viewModalRef = this._dialog.open(ChangeComponentComponent, {
          width: '500px',
          data: {
            eQunitId: component.ComponentId,
            comparttype_auto: component.ComponentTypeId,
            compartid_auto: component.CompartId_Auto,
            // shoeSizeId: component.ShoeSize ?? 0,
            // shoeGrouserId: component.GrouserId ?? 0,
            // cleanerHolesId: component.CleanerHolesId ?? 0,
            make: component.MakeId,
            budgetLife: component.BudgetLife,
            //masterLink: component.MLink,
            jobNumber: component.JobNumber,
           // bushTurnedBudgetPer: component.BushTurnedPercent,
            assetNumber: component.AssetNumber,
           // bushTurnedHour: component.BushTurnedBudgetLife,
            wornPercentage: component.WornPercentage,
            cmu: component.Cmu,
            screenId: ScreenCode.WF
          }
        });
        viewModalRef.afterClosed().subscribe(result => {
          console.log("viewModalRef.afterClosed() result:", result);
          if (result) {
            this.LoadFrameComponentsLeftAndRight();
          }
        });
      }
}
export enum WSREPhotoUpload {
  component = 0,
  dipTest = 1,
}